



























































































































































































































































































































































































































































import Vue from 'vue';
import ItemInput from '@/components/item/ItemInput.vue';
import ItemTooltip from '@/components/item/ItemTooltip.vue';
import ShipTooltip from '@/components/fleet/ShipTooltip.vue';
import Ship, { ShipBuilder } from '@/classes/fleet/ship';
import Item from '@/classes/item/item';
import ShipMaster from '@/classes/fleet/shipMaster';
import SiteSetting from '@/classes/siteSetting';
import ShipValidation from '@/classes/fleet/shipValidation';

export default Vue.extend({
  components: { ItemInput, ItemTooltip, ShipTooltip },
  name: 'ShipInput',
  props: {
    handleShowItemList: {
      type: Function,
      required: true,
    },
    handleShowShipList: {
      type: Function,
      required: true,
    },
    handleCloseShip: {
      type: Function,
      required: true,
    },
    handleShowTempShipList: {
      type: Function,
      required: true,
    },
    handleShowItemPreset: {
      type: Function,
      required: true,
    },
    value: {
      type: Ship,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    fixDown: {
      type: Number,
      default: 0,
    },
    rateDown: {
      type: Number,
      default: 0,
    },
    fleetRosCorr: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    level: 99,
    luck: 0,
    antiAir: 0,
    levelMenu: false,
    luckMenu: false,
    antiAirMenu: false,
    enabledTooltip: false,
    enabledShipTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipItem: new Item(),
    tooltipX: 0,
    tooltipY: 0,
    rangeText: ['', 'Short', 'Medium', 'Long', 'Very Long', 'Very Long+', 'Super Long', 'Super Long+', 'Longest', 'Longest+'],
  }),
  computed: {
    ship(): Ship {
      return this.value;
    },
    airPowerDetail(): string {
      const airPowers = this.ship.items.map((v) => (v.fullAirPower && !v.data.isRecon ? v.fullAirPower : 0));
      return airPowers.filter((v) => v > 0).length ? `( ${airPowers.join(' | ')} )` : '';
    },
    isNoShip(): boolean {
      return this.value.data.id === 0;
    },
    rateDownValue(): number {
      return Math.floor(this.rateDown * 100);
    },
    enabledConvert(): boolean {
      const ships = this.$store.state.ships as ShipMaster[];
      const master = this.value.data;
      return this.value.data.isFinal && ships.filter((v) => v.originalId === master.originalId && v.isFinal && v.version > 1).length >= 2;
    },
    maxAreas(): number {
      return this.$store.state.areaCount as number;
    },
  },
  methods: {
    updateItem() {
      this.setShip();
    },
    setShip(value?: Ship) {
      this.clearTooltip();
      if (value === undefined) {
        this.$emit('input', new Ship({ ship: this.ship }));
      } else {
        this.$emit('input', value);
      }
    },
    onLevelMenuToggle() {
      if (!this.levelMenu) {
        const asw = Ship.getStatusFromLevel(this.level, this.ship.data.maxAsw, this.value.data.minAsw);
        const builder: ShipBuilder = { ship: this.ship, level: this.level, asw };
        this.setShip(new Ship(builder));
      } else {
        this.level = this.ship.level;
      }
    },
    onLuckMenuToggle() {
      if (!this.luckMenu) {
        const builder: ShipBuilder = { ship: this.ship, luck: this.luck };
        this.setShip(new Ship(builder));
      } else {
        this.luck = this.ship.luck;
      }
    },
    onAAMenuToggle() {
      if (!this.antiAirMenu) {
        const builder: ShipBuilder = { ship: this.ship, antiAir: this.antiAir };
        this.setShip(new Ship(builder));
      } else {
        this.antiAir = this.ship.antiAir;
      }
    },
    changeActive(value: boolean) {
      this.setShip(new Ship({ ship: this.ship, isActive: value }));
    },
    resetItems() {
      this.setShip(new Ship({ ship: this.value, items: [], exItem: new Item() }));
    },
    removeShip() {
      this.handleCloseShip(this.index);
    },
    showItemList(slotIndex: number): void {
      this.clearTooltip();
      // 艦娘indexを付与してFleet.vueへスルーパス
      this.handleShowItemList(this.index, slotIndex);
    },
    showShipList(): void {
      // 艦娘indexを付与してFleet.vueへスルーパス
      this.clearTooltip();
      this.handleShowShipList(this.index);
    },
    showTempShip() {
      // 一時保存領域の展開
      this.handleShowTempShipList(this.index);
    },
    showItemPresets() {
      // 装備プリセット画面
      this.handleShowItemPreset(this.index);
    },
    toggleVersion() {
      const ships = this.$store.state.ships as ShipMaster[];
      const master = this.value.data;
      // コンバート候補取得
      const versions = ships
        .filter((v) => v.originalId === master.originalId && v.isFinal && v.version > 1)
        .sort((a, b) => a.version - b.version);
      // 現在のver
      const index = versions.findIndex((v) => v.id === master.id);
      let newVersion: ShipMaster;
      if (index < versions.length - 1) {
        // 一段階改装を進めたバージョンを設置
        newVersion = versions[index + 1];
      } else {
        // コンバート最初期状態へ
        newVersion = versions[index - index];
      }

      // 装備検証
      const { items, exItem } = this.value;
      const newItems = [];
      let newExItem: Item;
      for (let i = 0; i < newVersion.slots.length; i += 1) {
        const item = items[i];
        if (item && ShipValidation.isValidItem(newVersion, item.data, i)) {
          newItems.push(new Item({ item, slot: newVersion.slots[i] }));
        } else {
          newItems.push(new Item());
        }
      }
      if (ShipValidation.isValidItem(newVersion, exItem.data)) {
        newExItem = new Item({ item: exItem });
      } else {
        newExItem = new Item();
      }

      this.setShip(
        new Ship({
          master: newVersion,
          level: this.value.level,
          luck: this.value.luck,
          items: newItems,
          exItem: newExItem,
        }),
      );
    },
    setDraggable(e: MouseEvent) {
      const target = e.target as HTMLDivElement;
      const parent = target.closest('.ship-input') as HTMLDivElement;
      parent.setAttribute('draggable', 'true');
    },
    resetDraggable(e: MouseEvent) {
      const target = e.target as HTMLDivElement;
      const parent = target.closest('.ship-input') as HTMLDivElement;
      parent.setAttribute('draggable', 'false');
    },
    dragStart(e: DragEvent) {
      // 子要素(item)のドラッグイベントが先におこっているならキャンセル
      const draggingDiv = document.getElementById('dragging-item');
      if (draggingDiv) {
        return;
      }
      const target = e.target as HTMLDivElement;
      if (this.value.isEmpty || !target || !target.classList || !target.classList.contains('ship-input') || !target.draggable) {
        return;
      }
      target.style.opacity = '0.6';
      target.id = 'dragging-item';

      // ドラッグ中セーブデータを一時保持
      this.$store.dispatch('setDraggingShipData', this.value);

      // 一時的に全てのship-inputの子要素マウスイベントを消す
      const shipInputList = document.getElementsByClassName('ship-input');
      for (let i = 0; i < shipInputList.length; i += 1) {
        shipInputList[i].classList.add('dragging');
      }
    },
    dragLeave(e: DragEvent) {
      (e.target as HTMLDivElement).style.boxShadow = '';
    },
    dragEnter(e: DragEvent): void {
      const d = document.getElementById('dragging-item');
      const t = e.target as HTMLDivElement;
      if (!d || !d.classList.contains('ship-input') || !t || !t.classList.contains('ship-input')) {
        return;
      }
      // 受け入れ可能 背景色を青っぽく
      t.style.boxShadow = 'inset 0 0 80px rgba(20, 160, 255, 0.6)';
    },
    dropShip(e: DragEvent) {
      e.preventDefault();
      // 受け渡されたデータ
      const draggingDiv = document.getElementById('dragging-item');
      // そもそもドラッグ開始が正常になされているか
      if (!draggingDiv || !draggingDiv.classList.contains('ship-input')) {
        return;
      }

      // ドロップされる要素
      const target = e.target as HTMLDivElement;
      target.style.boxShadow = '';
      if (target.id) {
        // 自身へのドロップ禁止
        return;
      }
      // 一時退避していたデータをセット
      const moveData = this.$store.state.draggingShipData as Ship;
      // 自身をドラッグ元に受け渡すためセット
      this.$store.dispatch('setDraggingShipData', this.value);

      // インスタンスにセット
      this.setShip(moveData);

      draggingDiv.classList.add('move-ok');
    },
    dragEnd(e: DragEvent) {
      // まずは一時的に消していた全てのship-inputの子要素マウスイベントを復活
      const shipInputList = document.getElementsByClassName('ship-input');
      for (let i = 0; i < shipInputList.length; i += 1) {
        shipInputList[i].classList.remove('dragging');
      }

      const draggingDiv = document.getElementById('dragging-item') as HTMLDivElement;
      if (!draggingDiv || !draggingDiv.draggable || !draggingDiv.classList.contains('ship-input')) {
        // ドラッグ不可だったり、そもそもship-inputじゃなかったら以降受け入れない
        return;
      }
      const target = e.target as HTMLDivElement;
      target.style.opacity = '1';
      target.id = '';
      target.draggable = false;
      if (target.classList.contains('move-ok')) {
        target.classList.remove('move-ok');
      } else {
        return;
      }

      // 受け渡された対象の装備データと交換！
      const moveData = this.$store.state.draggingShipData as Ship;
      if (moveData) {
        // インスタンスにセット
        this.setShip(moveData);
      }
    },
    bootTooltip(item: Item, e: MouseEvent) {
      const setting = this.$store.state.siteSetting as SiteSetting;
      if (!item.data.id || setting.disabledItemTooltip) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('item-name')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = rect.x + rect.width / 3;
        this.tooltipY = rect.y + rect.height;
        this.tooltipItem = item;
        this.enabledTooltip = true;
      }, 400);
    },
    bootShipTooltip(e: MouseEvent) {
      this.tooltipTimer = window.setTimeout(() => {
        this.tooltipX = e.clientX;
        this.tooltipY = e.clientY;
        this.enabledShipTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      this.enabledShipTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
